import { SxProps } from '@mui/material';

export const locationOptionAliasSX: SxProps = {
	color: 'grey.500',
	textTransform: 'capitalize',
};

export const locationOptionFavoriteAddressSX: SxProps = {
	color: 'grey.200',
};

export const locationOptionAddressDetailSX: SxProps = {
	display: 'flex',
	color: 'grey.500',
	alignItems: 'center',
	gap: '5px',
	textTransform: 'capitalize',
};

export const locationOptionIconContainerSX: SxProps = {
	minWidth: '20px',
};

export const locationOptionEditSX: SxProps = {
	color: 'secondary.main',
	'&:hover': {
		cursor: 'pointer',
		textDecoration: 'underline',
	},
};

export const locationOptionSelectBtnSX: SxProps = {
	height: 41.56,
};
